export default {
    title: "Mesclar clientes",
    description: "Qual campo você deseja usar para mesclar os clientes?",
    fieldExternalId: "Id Integração",
    fieldEmail: "Email",
    fieldWhatsapp: "Telefone",
    previewButton: "Pré-visualizar",
    previewTitle: "Pré-visualização",
    clientsColumn: "Clientes",
    nameLabel: "Nome",
    emailLabel: "E-mail",
    whatsappLabel: "Whats",
    mergeButton: "Mesclar",
    selectFieldAlert: "Selecione um campo para mesclar os clientes",
    mergeSuccessAlert: "Clientes mesclados com sucesso",
};
